var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6168 11.7915C27.5293 11.7873 27.4418 11.7858 27.3543 11.787H23.7016C20.7134 11.787 18.1543 14.1586 18.1543 17.2518C18.1543 20.345 20.7134 22.7166 23.7031 22.7166H27.3528C27.4443 22.7166 27.5328 22.7166 27.6153 22.7106C28.2321 22.6712 28.8135 22.4089 29.2512 21.9726C29.6889 21.5362 29.9531 20.9556 29.9944 20.339C30.0004 20.2505 30.0004 20.1559 30.0004 20.0689V14.4347C30.0004 14.3477 30.0004 14.2532 29.9944 14.1646C29.9531 13.5482 29.6892 12.9678 29.2518 12.5315C28.8144 12.0952 28.2333 11.8328 27.6168 11.793V11.7915ZM23.3821 18.7084C24.1516 18.7084 24.7771 18.0573 24.7771 17.2518C24.7771 16.4463 24.1516 15.7952 23.3821 15.7952C22.6125 15.7952 21.9885 16.4463 21.9885 17.2518C21.9885 18.0573 22.611 18.7084 23.3821 18.7084Z",
    fill: "url(#paint0_linear_691_902)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3524 24.902C27.4026 24.9002 27.4526 24.9103 27.4982 24.9314C27.5439 24.9525 27.5839 24.984 27.6152 25.0234C27.6464 25.0628 27.668 25.109 27.6781 25.1583C27.6882 25.2075 27.6866 25.2585 27.6734 25.307C27.3824 26.3451 26.9218 27.2301 26.1823 27.9741C25.1008 29.0647 23.7282 29.5492 22.0331 29.7787C20.386 30.0022 18.2829 30.0022 15.6248 30.0022H12.5691C9.91249 30.0022 7.80789 30.0022 6.16081 29.7787C4.46572 29.5492 3.09315 29.0647 2.0116 27.9741C0.930046 26.8851 0.450022 25.502 0.222011 23.7934C0 22.1329 0 20.0118 0 17.3341V17.1691C0 14.4915 0 12.3689 0.222011 10.7098C0.450022 9.0012 0.930046 7.62113 2.0101 6.52758C3.09165 5.43852 4.46422 4.9525 6.15931 4.72449C7.80789 4.50098 9.91249 4.50098 12.5691 4.50098H15.6248C18.2814 4.50098 20.386 4.50098 22.0331 4.72449C23.7282 4.954 25.1008 5.43852 26.1823 6.52758C26.9218 7.27311 27.3824 8.15816 27.6734 9.19771C27.6863 9.24614 27.6877 9.29692 27.6774 9.34598C27.6672 9.39504 27.6456 9.44103 27.6144 9.48025C27.5832 9.51947 27.5433 9.55085 27.4978 9.57185C27.4522 9.59286 27.4025 9.60292 27.3524 9.60123H23.7027C19.6015 9.60123 15.9878 12.8669 15.9878 17.2516C15.9878 21.6363 19.603 24.902 23.7042 24.902H27.3524ZM5.42127 10.3303C5.27845 10.3309 5.13715 10.3596 5.00542 10.4148C4.8737 10.47 4.75414 10.5506 4.65357 10.652C4.553 10.7534 4.47339 10.8736 4.41928 11.0058C4.36517 11.138 4.33762 11.2795 4.33822 11.4223C4.33822 12.0269 4.82274 12.5159 5.42127 12.5159H11.2056C11.8056 12.5159 12.2901 12.0269 12.2901 11.4223C12.2909 11.1337 12.1771 10.8567 11.9738 10.6519C11.7704 10.4471 11.4941 10.3315 11.2056 10.3303H5.42127Z",
    fill: "url(#paint1_linear_691_902)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 3.03703L11.6032 0.872426C12.3696 0.305793 13.2976 0 14.2508 0C15.204 0 16.132 0.305793 16.8984 0.872426L19.8521 3.04903C18.616 3.00103 17.2359 3.00103 15.7254 3.00103H12.4702C11.0871 3.00103 9.81657 3.00103 8.66602 3.03703Z",
    fill: "url(#paint2_linear_691_902)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_691_902",
    x1: 15.352,
    y1: 22.7166,
    x2: 44.2985,
    y2: 22.7166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_691_902",
    x1: -6.54905,
    y1: 30.0022,
    x2: 61.0997,
    y2: 30.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_691_902",
    x1: 6.01985,
    y1: 3.04903,
    x2: 33.3535,
    y2: 3.04903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.aa8936d2fc6d497f920814e32aa60a2d.svg";
export { ForwardRef as ReactComponent };